import {
	FETCH_JOB_POSTINGS_SUCCESS,
	FETCH_JOB_POSTING_BY_ID_SUCCESS,
	JOB_POSTINGS_REQUEST_LOADING,
	JOB_POSTINGS_REQUEST_ERRORS
} from "api/menu/hr/job-postings/actions";

const initialState = {
	loading: false,
	errors: [],
	jobPostings: [],
	singleJobPosting: {}
};

export default function(state = initialState, action) {
	switch (action.type) {
		case JOB_POSTINGS_REQUEST_LOADING:
			return { ...state, loading: true };
		case JOB_POSTINGS_REQUEST_ERRORS:
			return { ...state, loading: false, errors: action.payload };
		case FETCH_JOB_POSTINGS_SUCCESS:
			return { ...state, loading: false, jobPostings: action.payload };
		case FETCH_JOB_POSTING_BY_ID_SUCCESS:
			return { ...state, loading: false, singleJobPosting: action.payload };
		default:
			return state;
	}
}


